/**
 * Frontend script for the Parallax Hero block.
 * Uses GSAP ScrollTrigger synced with the global Lenis smooth-scroll instance.
 *
 * The background image is rendered by the core/cover block nested inside
 * the parallax-hero wrapper. We target its image element directly.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

function initParallaxHeroes() {
	const blocks = document.querySelectorAll( '.wp-block-ritolakosalmi-parallax-hero' );

	if ( ! blocks.length ) {
		return;
	}

	// Sync ScrollTrigger with the Lenis instance initialised in front-end.js.
	// window.lenis is exposed globally by the theme's main JS.
	if ( window.lenis ) {
		window.lenis.on( 'scroll', ScrollTrigger.update );
	}

	blocks.forEach( ( block ) => {
		// Target the image (or video) rendered by the nested core/cover block.
		const image = block.querySelector(
			'.wp-block-cover .wp-block-cover__image-background, .wp-block-cover video'
		);

		if ( ! image ) return;

		const intensity = parseFloat( block.dataset.parallaxIntensity ) || 30;

		// Skip parallax if intensity is 0.
		if ( intensity === 0 ) return;

		// The cover block container has negative inset so the image is taller
		// than the block — giving it room to travel without exposing empty edges.
		gsap.fromTo(
			image,
			{ yPercent: -( intensity / 2 ) },
			{
				yPercent: intensity / 2,
				ease: 'none',
				scrollTrigger: {
					trigger: block,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			}
		);
	} );

	ScrollTrigger.refresh();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initParallaxHeroes );
} else {
	initParallaxHeroes();
}
